import { format } from 'date-fns'

export class GroupsQuery {
  ids?: number[]
  textSearch?: string | null
  statusIds?: number[] | null
  companyIds?: number[] | null
  centerIds?: number[] | null
  locationIds?: number[] | null
  dataSourceIds?: number[] | null
  shopCategoryIds?: number[] | null
  actionPhases?: string[] | null
  hasDataIssues?: boolean | null
  hasOpenDataGaps?: boolean | null
  isDataApproved?: boolean | null
  includeClosedShops?: boolean = false
  showEmptyGroups?: boolean = false
  includeShops?: boolean | null
  enabledMappingOutputIds?: number[] | null
  disabledMappingOutputIds?: number[] | null
  isIntegrated?: boolean | null
}

export class DateOnly {
  private readonly value: string
  private static readonly FORMAT_REGEX = /^\d{4}-\d{2}-\d{2}$/
  private static readonly formatString = 'yyyy-MM-dd'

  constructor(value: string) {
    if (!DateOnly.isValid(value)) {
      // Try parsing the string to a Date
      const parsed = Date.parse(value)

      if (typeof parsed !== 'number') {
        throw new Error(`Invalid format and unable to parse: ${value}`);
      }

      this.value = format(new Date(parsed), DateOnly.formatString)
      return
    }
    this.value = value;
  }

  static isValid(value: string): boolean {
    if (!this.FORMAT_REGEX.test(value)) return false;

    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);

    return date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day;
  }

  static fromDate(date: Date): DateOnly {
    return new DateOnly(format(date, this.formatString));
  }

  static fromNumber(value: number): DateOnly {
    const date = new Date(value)
    return new DateOnly(format(date, this.formatString))
  }

  static today(): DateOnly {
    return DateOnly.fromDate(new Date());
  }

  toString(): string {
    return this.value;
  }

  toJSON(): string {
    return this.value;
  }

  toNumber(): number {
    return new Date(this.value).valueOf()
  }

  toDate(): Date {
    return new Date(this.value);
  }

  format(locale: string = 'en-US'): string {
    return this.toDate().toLocaleDateString(locale);
  }
}